import { ProjectOrTask } from "../types";

export const getKey = ({ taskId, projectId }: ProjectOrTask = {}) => {
    if (!taskId && !projectId) {
        throw new Error("Both task id and project id can't be null.");
    }

    if (!!taskId && !!projectId) {
        throw new Error("Both projectId and taskId can't be specified");
    }

    return !!taskId ? `task_${taskId}` : `project_${projectId}`;
};
